import React from "react";
import { MdOutlineModeEdit } from "react-icons/md";
import TextComponent from "../textComponent/TextComponent";
import styles from "./ScheduleComponent.module.css";

const ScheduleComponent = ({
  title,
  label,
  labelClass,
  expectedtime,
  actualtime,
  ScheduleActualTimeStyle,
  expectedtimeStyle,
  actualtimeStyle,
  showEdit,
}) => {
  return (
    <div className={styles.scheduleCard}>

      {title && (
        <div className={styles.recipeTitleContainer}>
          <TextComponent className={styles.recipeTitle} fontFamily="Inter-Bold">
            {title}
          </TextComponent>
        </div>
      )}


      {label && (
        <TextComponent
          className={`${styles.label} ${labelClass || ""}`}
          fontFamily="Inter-semiBold"
        >
          {label}
        </TextComponent>
      )}


      <div className={styles.ScheduleExpectedTime}>
        <TextComponent>Expected Time</TextComponent>
        <div className={styles.ExpectedTimeEdit}>
          <TextComponent
            className={`${styles.expectedtime} ${expectedtimeStyle || ""}`}
          >
            {expectedtime}
          </TextComponent>
          {showEdit && (
            <div className={styles.EditIcon}>
              <MdOutlineModeEdit
                cursor="pointer"
                color="var(--white-color)"
                size={12}
              />
            </div>
          )}
        </div>
      </div>

      <div
        className={`${styles.ScheduleActualTime} ${ScheduleActualTimeStyle || ""
          }`}
      >
        <TextComponent className={styles.actualtime}>Actual Time</TextComponent>
        <TextComponent
          className={`${styles.actualtime} ${actualtimeStyle || ""}`}
        >
          {actualtime}
        </TextComponent>
      </div>
    </div>
  );
};

export default ScheduleComponent;
